<template>
  <div>
    <Row class="tab_context" type="flex" justify="space-around">
      <i-col span="12" class="tab_context_item">
        <div>
          <indexTabChat
            v-for="(item, index) in chars"
            :key="index"
            :isLeft="item.isLeft"
            :name="item.name"
            :icon="item.icon"
            :tabFontChat="item.tabFontChat"
          ></indexTabChat>
        </div>
      </i-col>
      <i-col span="8" class="tab_context_item">
        <indexTabImg icon="img-case-001.png"></indexTabImg>
      </i-col>
    </Row>
    <Row class="tab_context" type="flex" justify="space-around">
      <i-col span="8">
        <indexTabFontCenter
          title="项目评估"
          context="数据分析难度低，但数据分析师懂分析但不懂业务，负责的市场部门懂业务不懂方法，需要耗费大量时间对接。"
        ></indexTabFontCenter>
      </i-col>
      <i-col span="12">
        <indexTabFontCenter
          title="解决方案"
          context="基于MPai数据科学平台 —— 量化评价模块，5分钟让业务人员零基础编程上手对应业务需要的数学模型。"
        ></indexTabFontCenter>
      </i-col>
    </Row>
    <Row class="tab_context" type="flex" justify="space-around">
      <i-col span="8" class="tab_context_item">
        <indexTabImg icon="img-case-003.png"></indexTabImg>
      </i-col>
      <i-col span="12" class="tab_context_item">
        <div>
          <indexTabFont
            v-for="(item, index) in fontContext"
            :key="index"
            :title="item.title"
            :context="item.context"
          ></indexTabFont>
        </div>
      </i-col>
    </Row>
  </div>
</template>

<script>
import indexTabFont from "./tab/index-tab-font.vue";
import indexTabImg from "./tab/index-tab-img.vue";
import indexTabFontCenter from "./tab/index-tab-font-center.vue";
import indexTabChat from "./tab/index-tab-chat.vue";
export default {
  components: {
    indexTabFont,
    indexTabFontCenter,
    indexTabImg,
    indexTabChat
  },
  data() {
    return {
      chars: [
        {
          isLeft: true,
          name: "主管 大明",
          icon: "#icon-mpai-director",
          tabFontChat:
            "公司打算在珠三角地区铺设2000个快递柜，这是40000个备用选址，你们分析一下，选择出最优的2000个地址方案给我。"
        },
        {
          isLeft: false,
          name: "业务员 小王",
          icon: "#icon-mpai-salesman",
          tabFontChat:
            "作为底层跑市场的业务员，我虽然不会数据分析，但是我比较了解业务与选择内在条件。"
        },
        {
          isLeft: true,
          name: "数据分析师 小刚",
          icon: "#icon-mpai-Analyst",
          tabFontChat:
            "作为数据分析师，虽然我听到任务时，脑子就有一套科学的方法来规范化选址工作。但是因为我不懂业务，从未接触过这个领城，我很容易忽视一些细节条件，因此我需要与业务员对接实际情况。希望小王能表述清楚业务。"
        }
      ],
      fontContext: [
        {
          title: "效果",
          context:
            "至少避免了数据分析师<span style='color: #2d8cf0'>10个工作日</span>去对接理解业务的时间，节省下来的时间可为公司创造更多价值。<br/><br/>充分利用快递柜市场推广人员懂业务机的特性，基于业务理解设计的模型<span style='color: #2d8cf0'>更贴切市场需求</span>，同时提升了业务人员软实力。"
        },
        {
          title: "推广",
          context:
            "本例可推广至量化店铺选址、量化评价、忠实客户、量化定制员工绩效、量化分析最优推广渠道或市场方案等等。"
        }
      ]
    };
  }
};
</script>

<style scoped>
.tab_context {
  color: #000;
}
.tab_context_item {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
